import { createSlice } from "@reduxjs/toolkit";
import { resetStateThunk } from "redux/Thunks/Authentication";
import Constants, { defaultData, Icons } from "utils/Constants";
import loanConfigThunk, { getAllSubmitterLoanFormThunk } from "redux/Thunks/LoanFormConfig";

const initialState = {
  loading: "idle",
  refetchConfig: true,
  loanConfig: [],
  screens: [
    {
      name: "Credit Card",
      id: defaultData.CREDIT_CARD_SCREEN_ID,
      index: 4,
      screensInfo: {},
      suffixIcon: Icons.CREDIT_CARD,
    },
    {
      name: "Personal Loan",
      id: defaultData.PERSONAL_LOAN_SCREEN_ID,
      index: 1,
      screensInfo: {},
      suffixIcon: Icons.PERSONAL_LOAN,
    },
    {
      name: "Home Loan",
      id: defaultData.HOME_LOAN_SCREEN_ID,
      index: 0,
      screensInfo: {},
      suffixIcon: Icons.HOME_LOAN,
    },
    {
      name: "Business Loan",
      id: defaultData.BUSINESS_LOAN_SCREEN_ID,
      index: 2,
      screensInfo: {},
      suffixIcon: Icons.BUSINESS_LOAN,
    },
    {
      name: "Car Loan",
      id: defaultData.CAR_LOAN_SCREEN_ID,
      index: 3,
      screensInfo: {},
      suffixIcon: Icons.CAR_LOAN,
    },
    {
      name: "Education Loan",
      id: defaultData.EDUCATION_LOAN_SCREEN_ID,
      index: 5,
      screensInfo: {},
      suffixIcon: Icons.EDUCATION_LOAN,
    },
    {
      name: "Loan Against Property",
      id: defaultData.LOAN_AGAINST_PROPERTY_SCREEN_ID,
      index: 6,
      screensInfo: {},
      suffixIcon: Icons.HOME_LOAN,
    },
    {
      name: "Loan Against Security",
      id: defaultData.LOAN_AGAINST_SECURITY_SCREEN_ID,
      index: 7,
      screensInfo: {},
      suffixIcon: Icons.PERSONAL_LOAN,
    },
    {
      name: "Working Capital",
      id: defaultData.WORKING_CAPITAL_SCREEN_ID,
      index: 8,
      screensInfo: {},
      suffixIcon: Icons.HOME_LOAN,
    },
    {
      name: "Machinery Loan",
      id: defaultData.MACHINERY_LOAN_SCREEN_ID,
      index: 9,
      screensInfo: {},
      suffixIcon: Icons.HOME_LOAN,
    },
    {
      name: "Gold Loan",
      id: defaultData.GOLD_LOAN_SCREEN_ID,
      index: 10,
      screensInfo: {},
      suffixIcon: Icons.PERSONAL_LOAN,
    },
  ],
  dataLoading: "idle",
  loanData: [],
};

export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    updateLoanData(state, action) {
      const mongooseId = "_id";
      const index = state.loanData.findIndex(
        (item) => item?.[mongooseId] === action.payload[mongooseId]
      );
      state.loanData[index] = action.payload;
    },
    removeLoanData(state, action) {
      state.loanData = state.loanData.filter(
        (item) => item?.[Constants.MONGOOSE_ID] !== action.payload
      );
    },
  },

  extraReducers: {
    [loanConfigThunk.pending]: (state) => {
      state.loading = Constants.PENDING;
    },
    [loanConfigThunk.fulfilled]: (state, action) => {
      state.loading = Constants.FULFILLED;
      state.loanConfig[0] = action.payload.data;
      action.payload.data.data.screens.forEach((element, sIndex) => {
        const screenIndex = state.screens.findIndex((screen) => screen.id === element.screenId);
        if (screenIndex !== -1) {
          state.screens[screenIndex].index = sIndex;
          state.screens[screenIndex].screensInfo = element;
        }
      });
      state.refetchConfig = false;
    },
    [loanConfigThunk.rejected]: (state) => {
      state.loading = Constants.REJECTED;
    },
    [getAllSubmitterLoanFormThunk.pending]: (state) => {
      if (state.loanData.length === 0) state.dataLoading = Constants.PENDING;
    },

    [getAllSubmitterLoanFormThunk.fulfilled]: (state, { payload }) => {
      state.dataLoading = Constants.FULFILLED;
      // Use `byPassSlice: true` to avoid loading data into the slice.
      // For example, this is useful when calling an API to retrieve data for filters.
      // state.loanData = payload.data.data;
      if (!payload.byPassSlice && payload.type === "add") state.loanData = payload.data.data;
      else if (!payload.byPassSlice) state.loanData.push(...payload.data.data);
    },

    [getAllSubmitterLoanFormThunk.rejected]: (state) => {
      state.dataLoading = Constants.REJECTED;
    },

    [resetStateThunk.fulfilled]: (state) => {
      state.loading = Constants.IDLE;
      state.equipmentLoading = Constants.IDLE;
      state.refetchConfig = true;
      state.config = [];
      state.screens = initialState.screens;
    },
  },
});

export const { updateLoanData, removeLoanData } = configSlice.actions;

export default configSlice.reducer;
